import { useStore } from '../store'
export default (to, from, next) => {
  const store = useStore()
  const user = store.getters['auth/user']
  if (!user.group.routeName) return next({ name: 'error.401' })
  return next({ name: user.group.routeName })
}
